export default "__VITE_ASSET__CidsgcEZ__"